import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
} from "react-zoom-pan-pinch";
import { IZwibblerStyle } from "../../app/models/zwibbler";
import classNames from "classnames";
import { Rnd } from "react-rnd";
import { toast } from "react-toastify";

interface IParams {
  url: string;
  className?: string;
  addZwibblerLayer: boolean;
  zwibblerDivId: string;
  zwibblerStyle: IZwibblerStyle;
  createZwibblerCtx: () => Promise<void>;
  onRendering?: () => void;
  onImageLoad: (
    width: number,
    height: number,
    tag: HTMLDivElement | null
  ) => void;
  resizeHandler: () => void;
}

const ProtectedZwibblerDiv: React.FC<IParams> = ({
  url,
  className,
  addZwibblerLayer,
  zwibblerDivId,
  zwibblerStyle,
  createZwibblerCtx,
  onRendering,
  onImageLoad,
  resizeHandler,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {isNativeApp}= rootStore.commonStore
  const { logout } = rootStore.guestStore;
  const { loadProtectedImageOrVideo } = rootStore.meetingStore;
  const {
    isBrushEnabled,
    ZwibblerEnableReadOnlyMode,
    setisZoomed,
    isZoomed,
    saveZwibbler,
    zwibblerPng,
    zwibblerCtx,
  } = rootStore.zwibblerStore;
  const { isMobileMediaQuery } = rootStore.responsiveStore;
  const {
    isZoomPortionEnabled,
    setZoomPortionEnabled,
    zoomPortionCalculate,
    isSynced,
    setSharedObject
  } = rootStore.playerStore;
  const { zoomPortionDivStyle,
     setZoomPortionDiv,
     resizeHandlerZwibbler,
     calculateZoomPortionToDrag
     } = rootStore.zwibblerStore;
  const {sendSharedWidget}= rootStore.tenantStore;
  const [srcData, setSrcData] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef<null | HTMLDivElement>(null);
  const transformRef = useRef<null | ReactZoomPanPinchRef>(null);
  const ZwibblerRef = useRef<null | HTMLDivElement>(null);
  const resizeObserver = useRef<ResizeObserver | null>(null); // Initialize it as null with proper typing
  const [resizing, setResizing] = useState(false);
  const fullScreenDivStyle: React.CSSProperties = {
    position: "absolute",
    top: zwibblerStyle.top,
    left: zwibblerStyle.left,
    width: zwibblerStyle.width,
    height: zwibblerStyle.height,
  };
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 3px #CCCDCD",
    background: "#16000078",
  };

  const handleDragStop = (e: any, d: any) => {
    const componentZoomPortion = e.target.getBoundingClientRect();
    if (!isZoomed) {
      var _height = parseFloat(componentZoomPortion.height);
      var _width = parseFloat(componentZoomPortion.width);
      var _left = parseFloat(componentZoomPortion.left);
      var _top = parseFloat(componentZoomPortion.top);
      var positionx = parseFloat(d.x);
      var positiony = parseFloat(d.y);
     
    var recalculate= calculateZoomPortionToDrag(_top ,_left, _width,_height, positionx ,positiony)
      if(recalculate){
    setZoomPortionDiv(_top, _left, recalculate.width, recalculate.height, recalculate.positionX, recalculate.positionY);
      zoomPortionCalculate(recalculate.width, recalculate.height, recalculate.positionX, recalculate.positionY);
      }
    }
  };

  const handleResizeStop = (
    e: any,
    direction: any,
    ref: any,
    delta: any,
    d: any
  ) => {
    if (!isZoomed) {
      var _height = parseFloat(ref.style.height);
      var _width = parseFloat(ref.style.width);
      var _left = parseFloat(ref.style.left);
      var _top = parseFloat(ref.style.top);
      var positionx = parseFloat(d.x);
      var positiony = parseFloat(d.y);
      setZoomPortionDiv(_top, _left, _width, _height, positionx, positiony);
      zoomPortionCalculate(_width, _height, positionx, positiony);
    }
  };

  useEffect(() => {
    let isMounted = true;
    console.log("ProtectedZwibblerDiv");
    loadProtectedImageOrVideo(url).then((res) => {
      if (res && res.data) {
        let file = new File([res!.data], "zwibblerbgimage");
        let src = window.URL.createObjectURL(file);

        const fakeImage: HTMLImageElement = new Image();
        fakeImage.src = src;
        fakeImage.onload = () => {
          if (containerRef && containerRef.current && addZwibblerLayer) {
            onImageLoad(
              fakeImage.width,
              fakeImage.height,
              containerRef.current
            );

            setImageLoaded(true);
          }
        };
        if (isMounted) setSrcData(src);
      }
    }).catch((error) => {
      if(error.status === 401){
        toast.error("Unauthorized access", { autoClose: 1000, onClose: () => {
          if (window.location.href.includes("/guest")) {
            const pathAfterGuest = window.location.href.split("/guest")[1]; // Ottiene tutto dopo "/guest"
            logout(pathAfterGuest); 
          }else {
            window.location.href = "/";
          }
          }});
      }else{
        toast.error("Error loading image");
      }
    });
    return () => {
      isMounted = false;
    };
  }, [
    loadProtectedImageOrVideo,
    url,
    addZwibblerLayer,
    onImageLoad,
    isMobileMediaQuery,
    isZoomPortionEnabled,

  ]);

  useEffect(() => {
   
    let zoomRef = transformRef.current;

    if (imageLoaded && addZwibblerLayer) {
      createZwibblerCtx().then(() => {
         resizeHandler();
        if (onRendering) onRendering();
      });
   
      window.addEventListener("resize", resizeHandlerZwibbler);
    

    }
    return () => {
     
      if (zoomRef) zoomRef.resetTransform();
      if (imageLoaded && !addZwibblerLayer)
        window.removeEventListener("resize", resizeHandlerZwibbler);
    };
  }, [
    imageLoaded,
    addZwibblerLayer,
    createZwibblerCtx,
    onRendering,
    resizeHandler,
    
  ]);

  const handleZoomEvent = (scale: number) => {
    if (isBrushEnabled) ZwibblerEnableReadOnlyMode();
    if (scale <= 1) {
     setisZoomed(false);
    }
    else {
      setisZoomed(true);
      setZoomPortionEnabled(false);
      
    }
    if (scale > 1 && scale < 1.2) {
      saveZwibbler();
    }
    setSharedObject();  
    sendSharedWidget(); 
  };

  return (
    <>
      <TransformWrapper
        limitToBounds={true}
        panning={{ disabled: !isZoomed }}
        onZoom={(ref) => handleZoomEvent(ref.state.scale)}
        doubleClick={{ disabled: true }}
        ref={transformRef}
      >
        <TransformComponent wrapperClass="zoomImage" contentClass="zoomImage">
          <div
            ref={containerRef}
            className={className}
            style={{
              backgroundImage: `url("${srcData}")`,
              cursor:  "default",
            }}
          ></div>
          {addZwibblerLayer ? (
            <>
              <div
                ref={ZwibblerRef}
                className={classNames(isZoomed && "d-none")}
                id={zwibblerDivId}
                style={fullScreenDivStyle}
              ></div>
            </>
          ) : (
            <></>
          )}

          { !isNativeApp &&isZoomPortionEnabled &&
            !isSynced &&
            ZwibblerRef &&
            ZwibblerRef.current && (
              <>
                <Rnd
                minHeight={70}
                minWidth={70}
                  style={style}
                  default={{
                    x: zoomPortionDivStyle.position.x,
                    y: zoomPortionDivStyle.position.y,
                    width: zoomPortionDivStyle.width,
                    height: zoomPortionDivStyle.height,
                  
                  }}
                  position={zoomPortionDivStyle.position}
                  bounds={ZwibblerRef.current}
                  onDragStop={handleDragStop}
                  onResizeStop={handleResizeStop}
                  size={{width:  zoomPortionDivStyle.width, height: zoomPortionDivStyle.height}}
                ></Rnd>
              </>
            )}
          {isZoomed && <img src={zwibblerPng} style={fullScreenDivStyle} />}
        </TransformComponent>
      </TransformWrapper>
    </>
  );
};

export default observer(ProtectedZwibblerDiv);
